import PropTypes from 'prop-types';
import React from 'react';
import { NotificationTypeRow } from './NotificationTypeRow';

export class NotificationTypeGrid extends React.Component {
  render = () =>
    (<table className="table">
      <tbody>
        {
          this.props.rowsConfig.map(rowConfig =>
            (rowConfig.isEmailEnabled || rowConfig.isSmsEnabled ?
              <NotificationTypeRow
                key={rowConfig.name}
                emailProperty={rowConfig.emailProperty}
                smsProperty={rowConfig.smsProperty}
                typeLabel={rowConfig.typeLabel}
                isEmailEnabled={rowConfig.isEmailEnabled}
                isSmsEnabled={rowConfig.isSmsEnabled}
                isEmailChecked={rowConfig.isEmailChecked}
                isSmsChecked={rowConfig.isSmsChecked}
                onInputChange={rowConfig.handleInputChange}
                isSmsCheckboxReadOnly={rowConfig.isSmsCheckboxReadOnly}
                intl={this.props.intl}
                info={rowConfig.info}
              /> : null))
        }
      </tbody>
     </table>)
}

NotificationTypeGrid.propTypes = {
  rowsConfig: PropTypes.array.isRequired,
  intl: PropTypes.object.isRequired,
};
